import { render, staticRenderFns } from "./CaddieFeePopup.vue?vue&type=template&id=c4d87dbe&"
import script from "./CaddieFeePopup.vue?vue&type=script&lang=js&"
export * from "./CaddieFeePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports